import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatToLongDate(isoString: string): string {
  const date = new Date(isoString);

  const locale = localStorage.getItem("locale") || "nl";

  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  return date.toLocaleDateString(locale, options);
}

export const yearAccordingToEducationLevel = (educationLevel: string) => {
  switch (educationLevel) {
    case "VMBO":
      return [1, 2, 3, 4];
    case "HAVO":
      return [1, 2, 3, 4, 5];
    case "VWO":
      return [1, 2, 3, 4, 5, 6];
    default:
      return [1, 2, 3, 4, 5, 6];
  }
};

export const schoolYearOptions = (educationLevel: string) => {
  const years = yearAccordingToEducationLevel(educationLevel);
  return years.map((year) => ({
    label: String(year),
    value: year,
  }));
};

export const generateZip = (pdfData: Blob, documentTitle: string) => {
  const blob = new Blob([pdfData], { type: "application/zip" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  const fileName = `${documentTitle}.zip`;
  a.download = fileName;
  a.href = url;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

export const downloadFile = async (
  urlPath: string,
  filename?: string | null
) => {
  const fileUrl = `${urlPath}`;
  const downloadName = filename || urlPath.split("/").pop() || "download";

  try {
    const response = await fetch(fileUrl);
    if (!response.ok) throw new Error("Failed to download file");
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = objectUrl;
    anchor.download = downloadName;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    URL.revokeObjectURL(objectUrl);
  } catch {
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  }
};

export function truncateText(text: string, limit: number) {
  if (text.length <= limit) {
    return text;
  }
  return text.substring(0, limit) + ".....";
}
